module["exports"] = [
  "#{street_root}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/address/street_name.js
 ** module id = 242
 ** module chunks = 0
 **/